import { h } from 'preact';
import CandidateRow from './CandidateRow';

const EmptyTable = ({ party }) => {
  return (
    <div class="seat__race">
      <div class="race">
        <h4 class="race__title">
          <span>{party}</span>
        </h4>
        <table class="race__candidates">{CandidateRow.Header}</table>
        <div class="no_primary_candidates">No primary candidates running</div>
      </div>
    </div>
  );
};

export default EmptyTable;
